import { pagesModel } from '../../../pages';
import { pageSettingsModel } from '../../../page-settings';

import { fork, takeEvery, takeLatest } from 'redux-saga/effects';
import { templatesModel } from '../index';
import { aiModel } from '../../../ai';
import { conversionKitModel } from '../../../conversion-kit';

import { snippetsModel } from '../../../snippets';
import { tasksModel } from '../../../tasks';
import { callModel } from '../../../call';

export function* templateEditorPageWorker() {
  yield fork(aiModel.sagas.editorAiWorker);

  yield fork(conversionKitModel.sagas.watchUploadPopUpImage);

  yield fork(snippetsModel.sagas.snippetsWorker);

  yield fork(tasksModel.sagas.tasksWorker);

  yield takeEvery(
    pagesModel.actions.changePageIcon,
    pagesModel.sagas.changePageIcon
  );

  yield takeEvery(
    pagesModel.actions.changeBrandColor,
    pagesModel.sagas.changeBrandColor
  );
  yield takeEvery(
    pagesModel.actions.changePageStyle,
    pagesModel.sagas.changePageStyle
  );
  yield takeEvery(
    pageSettingsModel.actions.updateSeoConfiguration,
    pageSettingsModel.sagas.updateSeoConfiguration
  );
  yield takeEvery(
    templatesModel.actions.updateTemplateFromEditor,
    templatesModel.sagas.updateTemplateFromEditor
  );

  yield takeEvery(
    snippetsModel.actions.updateSnippetUsedCount,
    snippetsModel.sagas.updateSnippetUsedCount
  );

  yield takeEvery(
    templatesModel.actions.addContentItem,
    templatesModel.sagas.addContentItem
  );

  yield takeEvery(
    templatesModel.actions.duplicateContentItem,
    templatesModel.sagas.duplicateContentItem
  );

  yield takeEvery(
    templatesModel.actions.deleteContentItem,
    templatesModel.sagas.deleteContentItem
  );

  yield takeEvery(
    templatesModel.actions.updateContentItemFromTemplate,
    templatesModel.sagas.updateContentItemFromTemplate
  );

  yield takeEvery(
    templatesModel.actions.updateTemplateContentItem,
    templatesModel.sagas.updateTemplateContentItem
  );

  yield takeEvery(
    templatesModel.actions.updateTemplateContentItemOrder,
    templatesModel.sagas.updateTemplateContentItemOrder
  );

  yield takeLatest(
    callModel.actions.loadCallsForEditor,
    callModel.sagas.loadCallsForEditor
  );

  yield takeEvery(
    callModel.actions.loadCallDetailsForEditor,
    callModel.sagas.loadCallDetailsForEditor
  );

  yield takeEvery(
    callModel.actions.makeCallPublicFromEditor,
    callModel.sagas.makeCallPublicFromEditor
  );
}
